import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";

export class AddressSchemaDataModel extends BaseSchemaDataModel {
  addressCountry: String;
}

export class AddressSchemaModel extends BaseSchemaModel {
  model: AddressSchemaDataModel;

  constructor(model: AddressSchemaModel) {
    super(SCHEMA_TYPE.postalAddress, model.name, model.url);

    this.model = model;
  }

  get typeParams(): String {
    return this.type ? `"@type":"${this.type}"` : ``;
  }

  get addressCountryParams(): String {
    //eslint-disable-next-line
    return this.model.addressCountry ? `,"addressCountry":"${this.model.addressCountry?.replaceAll('\"', '\\"')}"` : ``;
  }

  toString(): String {
    return `{${this.typeParams}${this.addressCountryParams}}`;
  }
}
